export enum NotificationType {
	ERROR = "error",
	WARNING = "warning",
	BUSY = "busy",
	INFO = "info"
}
